import React, { createContext, useContext, useState, useCallback } from 'react';
import ReservationModal from '../components/ReservationModal';

const ReservationContext = createContext(null);

export const ReservationProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [presetPackage, setPresetPackage] = useState(null);

  const openReservation = useCallback((pkg = null) => {
    setPresetPackage(pkg);
    setOpen(true);
  }, []);

  const close = useCallback(() => setOpen(false), []);

  return (
    <ReservationContext.Provider value={{ openReservation }}>
      {children}
      <ReservationModal open={open} onClose={close} presetPackage={presetPackage} />
    </ReservationContext.Provider>
  );
};

export const useReservation = () => {
  const ctx = useContext(ReservationContext);
  if (!ctx) throw new Error('useReservation must be used within ReservationProvider');
  return ctx;
};
